import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import Clarity from '@microsoft/clarity';

import './index.css';
import { createQueryClient } from './api/queryClient';
import { App } from './App';

// Session analytics, prod host only so dev and local runs stay out of the project.
if (location.hostname === 'screenatlas.app') Clarity.init('z5ctlrri7z');

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* base path is /web — see web/docs/infra.md §Routing */}
      <BrowserRouter basename="/web">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
